<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="650px" :retain-focus="false">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title class="d-flex justify-space-between">
              <div>Application Details</div>
              <div class="ml-auto d-flex" v-if="actionType === 'FOR_CONFIRMATION'">
                <v-dialog ref="dialog" v-model="modal" :return-value.sync="dates" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" x-small v-bind="attrs" v-on="on">
                      <v-icon class="mr-2" x-small>mdi-phone</v-icon> Next Call
                      Date
                    </v-btn>
                  </template>
                  <v-date-picker v-model="dates">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="saveNextCall(dates)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </div>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-simple-table>
                      <template v-slot:default>
                        <!-- <thead>
                          <tr>
                            <th class="text-left">
                              Name
                            </th>
                            <th class="text-left">
                              Calories
                            </th>
                          </tr>
                        </thead> -->
                        <tbody>
                          <!-- <tr v-for="item in desserts" :key="item.name">
                            <td>{{ item.name }}</td>
                            <td>{{ item.calories }}</td>
                          </tr> -->
                          <tr>
                            <th>Name</th>
                            <td>
                              {{ selectedData.subscriberName }}

                            </td>
                          </tr>
                          <tr>
                            <th>Email Address</th>
                            <td>
                              {{ selectedData.emailAddress1 }}

                            </td>
                          </tr>
                          <tr>
                            <th>Contact Number</th>
                            <td>{{ selectedData.mobile1 }} <br />{{ selectedData.mobile2 }}</td>

                          </tr>
                          <tr>
                            <th>Address</th>
                            <td>{{ selectedData.address }}</td>
                          </tr>

                          <tr>
                            <th>Barangay</th>
                            <td>{{ selectedData.barangayName }}</td>
                          </tr>
                          <tr>
                            <th>City</th>
                            <td>{{ selectedData.municipalityName }}</td>
                          </tr>
                          <tr>
                            <th>Province</th>
                            <td>{{ selectedData.provinceName }}</td>
                          </tr>
                          <tr>
                            <th>Plan</th>
                            <td>{{ selectedData.subscriptionPackageName }}</td>
                          </tr>
                          <tr>
                            <th>Type</th>
                            <td>{{ selectedData.typeOfCustomer }}</td>
                          </tr>
                          <tr>
                          <th>Nap Code</th>
                            <td>{{ selectedData.napCode }}</td>
                          </tr>
                          <tr>
                            <th>Port Number</th>
                            <td>{{ selectedData.portNo }}</td>
                          </tr>
                          <tr>
                            <th>Disconnection Date</th>
                            <td>{{ formatDate(selectedData.disconnectionDate) }}</td>
                          </tr>
                          <tr>
                            <th>Subscriber Number</th>
                            <td>{{ selectedData.subscriberNumber }}</td>
                          </tr>
                          <tr v-if="actionType === 'INTERESTED'" >
                            <th>Remarks</th>
                            <td>{{ selectedData.pdsStatus.reason }}</td>
                          </tr>
                          <tr v-if="actionType === 'NOT_INTERESTED'" >
                            <th>Reason</th>
                            <td>{{ selectedData.pdsStatus.reason }}</td>
                          </tr>
                         

                          <!-- <tr v-if="selectedData.sku">
                            <th>Data Pack</th>
                            <td>
                              {{ selectedData.sku.skuName }} -
                              {{ selectedData.sku.price }}
                            </td>
                          </tr>

                          <tr v-if="actionType == 'installed'">
                            <th>Date Applied</th>
                            <td>
                              {{ formatDate(selectedData.createdDate) }}
                            </td>
                          </tr>
                          <tr v-if="actionType == 'installed'">
                            <th>Activation Date</th>
                            <td>
                              {{ formatDate(selectedData.activationDate) }}
                            </td>
                          </tr>
                          <tr v-if="actionType == 'installed'">
                            <th>Duration</th>
                            <td>
                              {{
                                duration(
                                  selectedData.createdDate,
                                  selectedData.activationDate
                                )
                              }}
                            </td>
                          </tr>
                          <tr v-if="actionType == 'cancelled'">
                            <th>Reason of Cancellation</th>
                            <td>
                              {{ selectedData.codReason }}
                            </td>
                          </tr> -->
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  
                  <v-col cols="12" class="mt-0 pt-0" v-if="this.resp.subscriberResponse === 'NOT_INTERESTED'">
                    <v-select label="Select Reason*" :items="reasonStatus" item-text="reason" item-value="reason"
                      v-model="resp.reason" :rules="rules.required" @change="onReasonNotInterested()">
                    </v-select>
                  </v-col>

                  <!--<v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      label="Select Assign To"
                      :items="assignToList"
                      v-model="form.assignedTo"
                      :rules="rules.required"
                    >
                    </v-select>
                  </v-col> -->
                  <!-- <v-col
                    cols="7"
                    class="mt-0 pt-0"
                    v-if="
                      actionType != 'installed' &&
                      actionType != 'cancelled' &&
                      actionType != 'paid'
                    "
                  >
                    <v-text-field
                      type="date"
                      name="installationDate"
                      :max="maxDate"
                      :min="minDate"
                      v-model="installationDate"
                      label="Installation Date"
                      :rules="rules.required"
                      @keydown.prevent="returnFalse()"
                    />
                  </v-col>
                  <v-col
                    cols="5"
                    class="mt-0 pt-0"
                    v-if="
                      actionType != 'installed' &&
                      actionType != 'cancelled' &&
                      actionType != 'paid'
                    "
                  >
                    <v-text-field
                      type="time"
                      name="installationDate"
                      v-model="installationTime"
                      label="Installation Time"
                      :rules="rules.required"
                    />
                  </v-col> -->
                </v-row>
              </v-container>
              <!-- <small>*indicates required field</small> -->
            </v-card-text>
            <v-card-actions class="pb-5">

              <!-- 
              <v-btn
                color="error"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click.prevent="onCancel()"
                v-if="actionType != 'installed' && actionType != 'cancelled'"
                class="px-10"
              >
                Cancel
              </v-btn> -->
              <v-btn v-if="actionType === 'FOR_CONFIRMATION'" color="primary" :loading="loadingBtn" :disabled="loadingBtn"
                @click.prevent="onSubmit()" class="px-10">
                Interested
              </v-btn>

              <v-btn v-if="actionType === 'FOR_CONFIRMATION'" color="primary" :loading="loadingBtn" :disabled="loadingBtn"
                @click.prevent="onNotInterested()" class="px-10">
                Not Interested
              </v-btn>
              <v-btn v-if="actionType === 'FOR_CONFIRMATION'" color="primary" :loading="loadingBtn" :disabled="loadingBtn"
                @click.prevent="onUncontactable()" class="px-10">
                Uncontactable
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn link :disabled="loadingBtn" text @click.native="cancel">
                Close
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-col>
    <Snackbar></Snackbar>
    <confirmation-diaglog ref="confirm"></confirmation-diaglog>
    <cod-cancellation-dialog ref="codCancel"></cod-cancellation-dialog>
    <remarks-dialog ref="remarksDialog"></remarks-dialog>
  </v-row>
</template>

<script>
// import moment from "moment";
import Snackbar from "../Snackbar.vue";
import ShareableMethods from "@/mixins/ShareableMethods";
import ConfirmationDiaglog from "../ConfirmationDiaglogv2.vue";
import CodCancellationDialog from "./CodCancellationDialog.vue";
import RemarksDialog from "../pds/RemarksDiaglog.vue";
import moment from "moment";

export default {
  mixins: [ShareableMethods],
  name: "OnlineApplicationDialog",

  components: {
    Snackbar,
    ConfirmationDiaglog,
    CodCancellationDialog,
    RemarksDialog
  },
  data() {
    return {
      dates: "",
      menu: false,
      modal: false,

      dispatchStatus: [],
      assignToList: [],
      reasonStatus: [],

      dialog: false,
      resolve: null,
      reject: null,

      selectedData: null,

      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },

      form: {
        referenceNumber: "",
        installationDate: "",
      },
      resp: {
        subscriberResponse: "",
        reason: "",
        type:"ESC"
      },

      installationDate: "",
      installationTime: "",
      maxDate: "",
      minDate: "",
      actionType: "",
      summaryReport: {},
      type: ""
    };
  },

  methods: {
    duration(start, end) {
      // console.log(start, end);
      const date1 = moment(new Date(start)).format("YYYY-DD-MM"); //todays date
      const date2 = moment(new Date(end)).format("YYYY-DD-MM"); // another date

      const newDate1 = moment(date1, "YYYY-DD-MM", true);
      const newDate2 = moment(date2, "YYYY-DD-MM", true);
      let totalDays = newDate2.diff(newDate1, "days");
      return `${totalDays} ${totalDays > 1 ? "days" : "day"}`;
    },

    returnFalse() {
      return false;
    },

    open(data, type) {

      console.log(type);
      console.log(data);
      this.actionType = data.subscriberResponse;
      this.dialog = true;
      this.form.referenceNumber = data.referenceNumber;

      this.selectedData = data;
      this.getReason();

      if (data?.installationDate) {
        const installationDate = data?.installationDate.split(" ");
        this.installationDate = installationDate[0];
        this.installationTime = installationDate[1];
      }

      // console.log(insta')

      this.maxDate = moment().add(3, "days").format("YYYY-MM-DD");

      this.minDate = moment().format("YYYY-MM-DD");
      // this.getDispatchConfig();
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    async getReason() {
      await this.$pds
        .get("/reason")
        .then((response) => {

          const data = response.data.data;
          // console.log(response)
          this.reasonStatus = data.reasons;
          console.log(data.reasons)
          // console.log("top bar", data)

        })
        .catch((e) => {
          console.log(e);
        });
    },
    async getSummaryReport() {
      await this.$pds
        .get("/pds?status=FOR_CONFIRMATION&type=ECS&page=1&limit=10")
        .then((response) => {
          const data = response.data;
          // console.log(response)
          this.summaryReport.forConfirmationTotal = data.totalCount.toLocaleString("en-US");
          // console.log("top bar", data)

        })
        .catch((e) => {
          console.log(e);
        });
      await this.$pds
        .get("/pds?status=INTERESTED&type=ECS&page=1&limit=10")
        .then((response) => {
          const data = response.data;
          // console.log(response)
          this.summaryReport.interestedTotal = data.totalCount;
          // console.log("top bar", data)

        })
        .catch((e) => {
          console.log(e);
        });

      await this.$pds
        .get("/pds?status=NOT_INTERESTED&type=ECS&page=1&limit=10")
        .then((response) => {
          const data = response.data;
          // console.log(response)
          this.summaryReport.notInterestedTotal = data.totalCount;
          // console.log("top bar", data)

        })
        .catch((e) => {
          console.log(e);
        });

      await this.$pds
        .get("/pds?status=UNCONTACTABLE&type=ECS&page=1&limit=10")
        .then((response) => {
          const data = response.data;
          // console.log(response)
          this.summaryReport.uncontactableTotal = data.totalCount;
          // console.log("top bar", data)

        })
        .catch((e) => {
          console.log(e);
        });

      console.log(this.summaryReport);
      this.$store.dispatch("addTicketSummaryReport", this.summaryReport);
    },
    async pastDue() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to confirm this application?"
        )
      ) {
        this.loadingBtn = true;
        this.form.installationDate = `${this.installationDate} ${this.installationTime}`;

        await this.$api
          .post("/online/cod/confirm", this.form)
          .then((response) => {
            const res = response.data;
            console.log(res);

            if (!res.status) {
              this.loadingBtn = false;
              this.$store.dispatch("addSnackbarMessage", res.message);
              this.$store.dispatch("addSnackbar", true);
              return;
            }

            this.loadingBtn = false;
            // this.$refs.form.reset();
            this.$store.dispatch(
              "addSnackbarMessage",
              "Successfully submitted."
            );
            this.$store.dispatch("addSnackbar", true);
            this.agree();
          })
          .catch((e) => {
            console.log(e);
            this.loadingBtn = false;
          });
      }
    },

    async onSubmit() {
      // if (!this.$refs.form.validate()) {
      //   return false;
      // }
      const cancelReason = await this.$refs.remarksDialog.open();
    console.log(cancelReason);

    if (cancelReason.status) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to confirm this application?"
        )
      ) {
        this.loadingBtn = true;
        // this.form.id = `${this.selectedData.id}`;
        this.resp.subscriberResponse = "INTERESTED";
        this.resp.reason=cancelReason.reason;
        await this.$pds
          .put("/pds-status/" + this.selectedData.id, this.resp)
          .then((response) => {
            const res = response.data;
            console.log(res);

            if (!res.status) {
              this.loadingBtn = false;

              this.$store.dispatch("addSnackbarMessage", res.message);
              this.$store.dispatch("addSnackbar", true);
              this.getSummaryReport();

              return;
            }

            this.loadingBtn = false;
            // this.$refs.form.reset();
            this.$store.dispatch(
              "addSnackbarMessage",
              "Successfully submitted."
            );
            this.$store.dispatch("addSnackbar", true);
            this.agree();

          })
          .catch((e) => {
            console.log(e);
            this.loadingBtn = false;
          });
      }
    }

      
    },
   
    onNotInterested() {
      // if (!this.$refs.form.validate()) {
      //   return false;
      // }

      this.loadingBtn = true;


      this.resp.subscriberResponse = "NOT_INTERESTED";


      this.loadingBtn = false;
      return;

    },
    async onReasonNotInterested() {
      // if (!this.$refs.form.validate()) {
      //   return false;
      // }

      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to confirm this application?"
        )
      ) {
        this.loadingBtn = true;

        // this.form.id = `${this.selectedData.id}`;
        this.resp.subscriberResponse = "NOT_INTERESTED";

        await this.$pds
          .put("/pds-status/" + this.selectedData.id, this.resp)
          .then((response) => {
            const res = response.data;
            console.log(res);

            if (!res.status) {
              this.loadingBtn = false;
              this.$store.dispatch("addSnackbarMessage", res.message);
              this.$store.dispatch("addSnackbar", true);
              this.getSummaryReport();
              return;
            }

            this.loadingBtn = false;
            // this.$refs.form.reset();
            this.$store.dispatch(
              "addSnackbarMessage",
              "Successfully submitted."
            );
            this.$store.dispatch("addSnackbar", true);
            this.agree();


          })
          .catch((e) => {
            console.log(e);
            this.loadingBtn = false;
          });
      }

    },
  
  async onUncontactable() {
    // if (!this.$refs.form.validate()) {
    //   return false;
    // }

    if (
      await this.$refs.confirm.open(
        "Confirm",
        "Are you sure you want to confirm this application?"
      )
    ) {
      this.loadingBtn = true;
      // this.form.id = `${this.selectedData.id}`;
      this.resp.subscriberResponse = "UNCONTACTABLE";
      await this.$pds
        .put("/pds-status/" + this.selectedData.id, this.resp)
        .then((response) => {
          const res = response.data;
          console.log(res);

          if (!res.status) {
            this.loadingBtn = false;
            this.$store.dispatch("addSnackbarMessage", res.message);
            this.$store.dispatch("addSnackbar", true);
            this.getSummaryReport();
            return;
          }

          this.loadingBtn = false;
          // this.$refs.form.reset();
          this.$store.dispatch(
            "addSnackbarMessage",
            "Successfully submitted."
          );
          this.$store.dispatch("addSnackbar", true);
          this.agree();

        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });
    }
  },
  agree() {
    this.resolve(true);
    this.dialog = false;

  },

  cancel() {
    this.resolve(false);
    this.dialog = false;
  },

  async onCancel() {
    const cancelReason = await this.$refs.codCancel.open();
    console.log(cancelReason);

    if (cancelReason.status) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to cancel this application?"
        )
      ) {
        this.loadingBtn = true;
        await this.$api
          .post("/online/cod/cancel", {
            referenceNumber: this.selectedData.referenceNumber,
            reason: cancelReason.reason,
          })
          .then((response) => {
            const res = response.data;
            this.loadingBtn = false;
            console.log(res);
            if (!res.status) {
              this.loadingBtn = false;
              this.$store.dispatch("addSnackbarMessage", res.messge);
              this.$store.dispatch("addSnackbar", true);
              this.getSummaryReport();
              return;
            }
            this.loadingBtn = false;
            this.$refs.form.reset();
            this.$store.dispatch("addSnackbarMessage", res.message);
            this.$store.dispatch("addSnackbar", true);
            this.agree();
          })
          .catch((e) => {
            console.log(e);
            this.loadingBtn = false;
          });
      }
    }
  },

  async saveNextCall(date) {
    if (
      await this.$refs.confirm.open(
        "Confirm",
        "Are you sure you want to update next call date?"
      )
    ) {
      const payload = {
        pdsId: this.selectedData.id,
        nextCallDate: date,
      };
      await this.$pds
        .post("/next-call", payload)
        .then((response) => {
          const res = response.data;
          console.log(res);

          // if (!res.status) {
          //   this.loadingBtn = false;
          //   this.$store.dispatch("addSnackbarMessage", res.message);
          //   this.$store.dispatch("addSnackbar", true);
          //   return;
          // }

          this.loadingBtn = false;
          // this.$refs.form.reset();
          this.$store.dispatch("addSnackbarMessage", "Next Call date has been Updated");
            this.$store.dispatch("addSnackbar", true);
          this.agree();
        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });
    }
  },
},

created() { },
};
</script>

<style scoped>
.images>img {
  cursor: pointer;
}
</style>
